/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@compiled/react';
import { expVal } from '@atlassian/jira-feature-experiments';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { IssueCommentReactionsBoundary } from '../comment-reactions/async.tsx';
import IssueCommentReactions from '../comment-reactions/index.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import { useCommentInteraction } from './utils.tsx';

const CommentReactions = () => {
	const { showReactions, isHighlighted, commentId } = useCommentContext();
	const onCommentInteraction = useCommentInteraction();

	if (!showReactions) {
		return null;
	}
	return (
		<div
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			data-testid="issue-comment-base.ui.comment.reactions-container"
			css={reactionsContainerStyles}
		>
			<IssueCommentReactionsBoundary packageName="issue" fallback={<></>}>
				<UFOSegment name="IssueCommentReactions">
					<IssueCommentReactions
						commentId={commentId}
						showQuickReactions={
							expVal(
								'thor_surface_reaction_comment_experiment',
								'isSurfaceReactionsEnabled',
								false,
							) && isHighlighted
						}
						onReactionSuccess={onCommentInteraction}
					/>
				</UFOSegment>
			</IssueCommentReactionsBoundary>
		</div>
	);
};

const reactionsContainerStyles = css({
	height: '20px',
	minHeight: 'fit-content',
});
export default CommentReactions;
